angular.module('impactx.invoice').controller('AcceptedUnmatchedListCtrl', [
    'selectedListItems',
    '$redirect',
    'dataGen',
    'BackService',
    'ToastService',
    'TranslationService',
    AcceptedUnmatchedListCtrl
]);

function AcceptedUnmatchedListCtrl(selectedListItems, $redirect, dataGen, BackService, ToastService, TranslationService) {
    var self = this

    self.dnhIds = $redirect.getLastParameters()

    self.match = function () {
        var dataObj = {
            blhId: selectedListItems.getFirstSelectedId(),
            dnhIds: self.dnhIds
        }
        dataGen.postAsForm({}, dataObj, "/invoice/unmatchedaccepted/match").then(function () {
            ToastService.openStandardToast(TranslationService.get('SaveSuccess'));
            BackService.back();
        });
    }

    var buttonDefinition = [
        {
            label: "match",
            action: self.match,
            type: 'dialogaction',
            condition: selectedListItems.isSingleSelection,
            process: 'AcceptUnmatchedInvoice'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/invoice/templates/custominvoicelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/invoice/unmatchedaccepted/list',
        id: "AcceptedUnmatchedList",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    self.getMeta = function () {
        return self.meta;
    };
}